import ResultsController from './results.controller';
import template from './results.html';
import './results.less';

const ResultsContainer = {
  bindings: {},
  template,
  controller: ResultsController
};

export default ResultsContainer;



// WEBPACK FOOTER //
// ./src/containers/results/results.component.js